import type { RegistrationResponseJSON } from "@simplewebauthn/server";
import { z } from "zod";

export default {
  params: z.object({
    webAuthnRegistrationResponse: z.custom<RegistrationResponseJSON>(),
  }),
  response: z.object({
    success: z.boolean(),
  }),
};
